'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Copyright 2017, IOOF Holdings Limited.
                                                                                                                                                                                                                                                                   * All rights reserved.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _wrapDisplayName = require('recompose/wrapDisplayName');

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _reduxSubspace = require('redux-subspace');

var _reactReduxSubspace = require('react-redux-subspace');

var _lodash = require('lodash.isplainobject');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withReducer = function withReducer(bundledReducer, identifier) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$namespaceActions = _ref.namespaceActions,
        namespaceActions = _ref$namespaceActions === undefined ? true : _ref$namespaceActions,
        _ref$mapExtraState = _ref.mapExtraState,
        mapExtraState = _ref$mapExtraState === undefined ? function () {
        return undefined;
    } : _ref$mapExtraState;

    var namespace = undefined;
    var reducer = bundledReducer;
    var options = {
        namespaceActions: namespaceActions,
        mapExtraState: mapExtraState
    };

    if (options.namespaceActions) {
        namespace = identifier;
        reducer = (0, _reduxSubspace.namespaced)(namespace)(bundledReducer);
    }

    var mapState = function mapState(state, rootState) {
        var componentState = state[identifier];
        var extraState = mapExtraState(state, rootState);
        return (0, _lodash2.default)(componentState) && (0, _lodash2.default)(extraState) ? _extends({}, extraState, componentState) : componentState;
    };

    var subspaceEnhancer = (0, _reactReduxSubspace.subspaced)(mapState, namespace);

    return function (WrappedComponent) {
        var Component = subspaceEnhancer(WrappedComponent);

        var ComponentWithReducer = function (_React$PureComponent) {
            _inherits(ComponentWithReducer, _React$PureComponent);

            function ComponentWithReducer(props, context) {
                _classCallCheck(this, ComponentWithReducer);

                var _this = _possibleConstructorReturn(this, (ComponentWithReducer.__proto__ || Object.getPrototypeOf(ComponentWithReducer)).call(this, props, context));

                var storeNamespace = _this.context.store.namespace;
                _this.state = {
                    identifier: storeNamespace ? storeNamespace + '/' + identifier : identifier,
                    namespacer: (0, _reduxSubspace.namespaced)(_this.context.store.namespace)
                };
                return _this;
            }

            _createClass(ComponentWithReducer, [{
                key: 'componentWillMount',
                value: function componentWillMount() {
                    var attachReducersCheck = typeof this.context.store.attachReducers === 'function';

                    if (process.env.NODE_ENV !== 'production') {
                        console.assert(attachReducersCheck, '\'store.attachReducers\' function is missing: Unable to attach reducer \'' + identifier + '\' into the store.');
                    }

                    if (attachReducersCheck) {
                        var _state = this.state,
                            _identifier = _state.identifier,
                            namespacer = _state.namespacer;

                        this.context.store.attachReducers(_defineProperty({}, _identifier, namespacer(reducer)));
                    }
                }
            }, {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(Component, this.props);
                }
            }]);

            return ComponentWithReducer;
        }(_react2.default.PureComponent);

        (0, _hoistNonReactStatics2.default)(ComponentWithReducer, Component);

        ComponentWithReducer.displayName = (0, _wrapDisplayName2.default)(WrappedComponent, 'ComponentWithReducer(' + identifier + ')');

        ComponentWithReducer.contextTypes = {
            store: _propTypes2.default.object
        };

        ComponentWithReducer.createInstance = function (instanceIdentfier) {
            return withReducer(bundledReducer, instanceIdentfier, options)(WrappedComponent);
        };

        ComponentWithReducer.withExtraState = function (mapExtraState) {
            return withReducer(bundledReducer, identifier, _extends({}, options, { mapExtraState: mapExtraState }))(WrappedComponent);
        };

        ComponentWithReducer.withOptions = function (overrideOptions) {
            return withReducer(bundledReducer, identifier, _extends({}, options, overrideOptions))(WrappedComponent);
        };

        return ComponentWithReducer;
    };
};

exports.default = withReducer;